import { TFunction } from 'i18next';
import { AddToastParams, getMessagesControl } from 'providers/Toast';
import { ProjectTag } from 'entities';

export type TagToValidate = {
  id: string | undefined;
  name: string;
  color: string;
  projectTags: ProjectTag[];
};

export const MESSAGES = getMessagesControl({
  notFilledTagName: (t) => ({
    title: t('tag-name-is-required'),
    type: 'info',
  }),

  hasNotColor: (t) => ({
    title: t('you-need-to-provide-a-color'),
    type: 'info',
  }),

  hasSameTagName: (t) => ({
    title: t('the-tag-name-already-exists-please-choose-another-one'),
    type: 'info',
  }),

  hasSameTagColor: (t) => ({
    title: t('this-color-already-exists-please-choose-another-one'),
    type: 'info',
  }),
});

const VALIDATION_RULES = [
  {
    check: (tag: TagToValidate) => !tag.name.trim(),
    getMessage: (t: TFunction) => MESSAGES.notFilledTagName(t),
  },
  {
    check: (tag: TagToValidate) => !tag.color,
    getMessage: (t: TFunction) => MESSAGES.hasNotColor(t),
  },
  {
    check: (tag: TagToValidate) =>
      tag.projectTags.find(({ name, id }) => tag.name.trim() === name && tag?.id !== id),
    getMessage: (t: TFunction) => MESSAGES.hasSameTagName(t),
  },
  {
    check: (tag: TagToValidate) =>
      tag.projectTags.find(({ color, id }) => tag.color === color && tag?.id !== id),

    getMessage: (t: TFunction) => MESSAGES.hasSameTagColor(t),
  },
];

export function validateTag(tag: TagToValidate, t: TFunction): AddToastParams | undefined {
  const validationResult = VALIDATION_RULES.find(({ check }) => check(tag));
  return validationResult?.getMessage(t);
}
